import { Select } from "antd";
import type { ClinicianListItem } from "@/portals/clinician/api/types";
import { clinicianName } from "@/portals/clinician/lib/clinicianName";

interface ClinicianPickerProps {
  clinicians: ClinicianListItem[];
  value: string | undefined;
  onChange: (userId: string) => void;
  /** A clinician not to offer (e.g. the one already assigned). */
  excludeUserId?: string;
}

/** Searchable clinician select — shared by patient assignment (Module 4) and queue assignment (Module 6). */
export function ClinicianPicker({ clinicians, value, onChange, excludeUserId }: ClinicianPickerProps) {
  return (
    <Select
      aria-label="Clinician"
      className="!w-full"
      placeholder="Select a clinician"
      value={value}
      onChange={onChange}
      showSearch
      optionFilterProp="label"
      options={clinicians
        .filter((p) => p.userId !== excludeUserId)
        .map((p) => ({ value: p.userId, label: clinicianName(p) === p.email ? p.email : `${clinicianName(p)} · ${p.email}` }))}
    />
  );
}
